<div id="mask" class="" style="display: block; opacity: 0.8;"></div>
<div id="first_window" class="modalWindow media-player-wrapper"
  style="top: 50%; left: 50%; display: block; position: fixed; transform: translate(-50%, -50%);">
  <div class="modal-header clearfix">
    <div class="width100 bold-txt">
      <!-- <span [innerHTML]="Header"></span> -->
      <div style="position: absolute; top: 8px; right: -5px;" class="fr txt-right close-icon close_modal"
        (click)="Close()" tabindex="0" aria-label="Close" role="button" (keydown)="CloseKeyboard($event)">
      </div>
    </div>
  </div>
  <div class="modal-body" style="text-align: left;">
    <ng-container *ngIf="isVideoFile;else audioFile">
      <video width="100%" [src]="path" controls disablepictureinpicture controlslist="nodownload" oncanplay="this.play()">
        Your browser does not support video element.
      </video>
    </ng-container>

    <ng-template #audioFile>
      <audio width="100%" [src]="path" controls autoplay controlslist="nodownload">
        Your browser does not support the audio element.
      </audio>
    </ng-template>
  </div>
</div>
